export default class Dialog {

    static confirmAction(message, title, options = {
        404: 'Não encontrado',
        500: 'Erro interno',
        409: 'Sua tela está desatualizada'
    }) {

        return new Promise((resolve, reject) => {

            const result = window.confirm(message);
            if (result) {
                resolve(true);
            } else {
                reject();
            }
        })


    }

}
